import {Base, NevoboResponse} from "../base";
import {Vereniging} from "./types";

export class Verenigingen extends Base {

    /**
     * @param vereniging if vereniging is not valid, this request returns the first page of getAllSportHallen()
     */
    getVereniging(vereniging: string): Promise<NevoboResponse<Vereniging>> {
        if (vereniging === "") {
            return this.getArgumentErrorPromise("Vereniging cannot be empty.")
        }
        return this.request<Vereniging>(`relatie/verenigingen/${vereniging}`);
    }

}
